/**
 * Status/role chips. Every chip pairs its color with a text label and a glyph
 * (via `data-glyph`) so status is never conveyed by color alone (accessibility §9).
 */

import type { Role } from "../api/types";
import { ROLE_LABEL } from "../lib/capabilities";

const ROLE_GLYPH: Record<Role, string> = {
  owner: "★",
  admin: "◆",
  creator: "●",
  runner: "○",
};

export function RoleChip({ role }: { role: Role }) {
  return (
    <span className={`chip chip--${role}`} data-glyph={ROLE_GLYPH[role]}>
      {ROLE_LABEL[role]}
    </span>
  );
}

export function LockedChip({ holder }: { holder: string }) {
  return (
    <span className="chip chip--locked" data-glyph="⚿" title={`Locked by ${holder}`}>
      Locked
    </span>
  );
}

export function TrashedChip() {
  return (
    <span className="chip chip--trashed" data-glyph="⌫">
      Trashed
    </span>
  );
}

/** An outside-domain guest invite (TRE-851) — joins this account as a guest on first sign-in. */
export function GuestChip() {
  return (
    <span className="chip chip--guest" data-glyph="◇" title="Outside your firm's domain — joins as a guest">
      Guest
    </span>
  );
}
